import React from 'react';
import PrimaryButton from '../buttons/PrimaryButton';

function TextModal({onClose, title, text, button=null}) {
  return (
    <div id="popup-modal" tabindex="-1" class="mx-auto w-full fixed inset-0 flex items-center justify-center overflow-auto">
      <div class="relative w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow-xl">
          <button onClick={onClose} type="button" class="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center" data-modal-hide="popup-modal">
            <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
            </svg>
            <span class="sr-only">Close modal</span>
          </button>
          <div class="pl-6 pt-4">
            <p className='text-lg font-bold text-center'>{title}</p>
          </div>
          
          <div class="pl-6 text-left pt-8 pb-4">
            <p class="mb-5 text-md font-normal text-gray-500">{text}</p>
          </div>

          {button ? (   
            <div className='pb-4 text-center'>
              <a href="#" onClick={button.action}>
                <PrimaryButton type={"button"} value={button.name} loading={false} />
              </a>
            </div>
          ) : null }
        </div>
      </div>
    </div>
  );
}

export default TextModal;